interface ShowProps {
  show: boolean;
}

function withShow<P extends object>(
  Component: React.ComponentType<P>
): React.FC<P & ShowProps> {
  const WrappedComponent = ({ show, ...props }: ShowProps & P) =>
    show ? <Component {...(props as P)} /> : null;
  
  WrappedComponent.displayName = `withShow(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
}

export default withShow;